import React from 'react';
import { Link } from 'react-router-dom';
import { Donor } from '../models/Donor';
import IconMan from '../images/common/icon_man11.png';
import IconMan2x from '../images/common/icon_man11@2x.png';
import IconSquareHat from '../images/common/icon_square_hat.png';
import IconSquareHat2x from '../images/common/icon_square_hat@2x.png';
import IconMapPin from '../images/common/icon_map_pin.png';
import IconMapPin2x from '../images/common/icon_map_pin@2x.png';
import FlagJa from '../images/common/flag_ja.png';
import FlagJa2x from '../images/common/flag_ja@2x.png';
import { ReactComponent as IconLicense } from '../images/common/license.svg';
import { ReactComponent as IconFlask } from '../images/common/triangle-flask.svg';
import './DonorCard.scss';

type Props = {
  donor: Donor;
  onClick?: () => void;
}

const DonorCard = ({ donor, onClick }: Props) => {
  return (
    <div className="donor-card">
      <Link to={ `/donor/${ donor.userNo }` } onClick={ onClick }>
        <div className="top-section">
          <div className="thumb">
            { donor.visiblePhotoUrl ? (
              <img
                src={ donor.visiblePhotoUrl }
                alt={ donor.initialName }
              />
            ) : (
              <img
                src={ IconMan }
                srcSet={ `${ IconMan } 1x, ${ IconMan2x } 2x` }
                alt={ donor.initialName }
              />
            ) }
          </div>
          <div className="cont">
            <h3>
              <span>{ donor.initialName }</span>
              &nbsp;{ donor.basicInfo.age }歳 / { donor.physicalInfo.bloodType }型
              { donor.basicInfo.nationality === 'JAPANESE' && donor.basicInfo.race === 'JAPANESE' && (
                <img
                  className="flag-ja"
                  src={ FlagJa }
                  srcSet={ `${ FlagJa } 1x, ${ FlagJa2x } 2x` }
                  alt="日本"
                />
              ) }
            </h3>
            <p>{ donor.physicalInfo.height }cm / { donor.physicalInfo.weight }kg</p>
            <div className="cert-badges">
              <div className={ `cert-badge ${ donor.isKycCertified ? 'certified' : '' }` }>
                <IconLicense />
              </div>
              <div className={ `cert-badge ${ donor.std.certified ? 'certified' : '' }` }>
                <IconFlask />
              </div>
              <div className={ `cert-badge text ${ donor.semen.validTotal ? 'certified' : '' }` }>
                { donor.semen.validTotal || '-' }
              </div>
            </div>
            <p className="education">
              <img
                src={ IconSquareHat }
                srcSet={ `${ IconSquareHat } 1x, ${ IconSquareHat2x } 2x` }
                alt="学歴"
              />
              <span>
                { ['BA', 'BS'].includes(donor.basicInfo.majorType) && `[${ donor.basicInfo.majorTypeText.slice(0,1) }]` }
                { donor.basicInfo.college || donor.basicInfo.collegeTypeText || donor.basicInfo.major }
              </span>
            </p>
            <div className="areas">
              <img
                src={ IconMapPin }
                srcSet={ `${ IconMapPin } 1x, ${ IconMapPin2x } 2x` }
                alt="提供エリア"
              />
              <div className="areas-list">
                { donor.basicInfo.areasText.length > 0 ? (
                  <>
                    { donor.basicInfo.areasText.slice(0, 4).map((area, i) => (
                      <span key={ i }>{ area }</span>
                    )) }
                    { donor.basicInfo.areasText.length > 4 && (
                      <span className="more">+{ donor.basicInfo.areasText.length - 4 }</span>
                    ) }
                  </>
                ) : (
                  <span className="empty">-</span>
                ) }
              </div>
            </div>
            { /*
            <p className="eyelid">
              <img
                src={ IconEye }
                srcSet={ `${ IconEye } 1x, ${ IconEye2x } 2x` }
                alt="まぶた"
              />
              <span>{ donor.physicalInfo.eyelidText || '-' }</span>
            </p>
            <dl>
              <dt>本人確認</dt>
              <dd>{ donor.isKycCertified ? '◎' : '-' }</dd>
              <dt>性病検査</dt>
              <dd>{ donor.std.certified ? '◎' : '-' }</dd>
              <dt>精子品質</dt>
              <dd>{ donor.semen.validTotal || '-' }</dd>
            </dl>
            */ }
            <p className="review-info">
              { donor.reviewSummary && donor.reviewSummary.reviewCount > 0 && !donor.reviewSummary.isHidden ? (
                <>
                  <span className="review-stars">{ donor.reviewSummary.stars }</span>
                  <span className="review-count">（{ donor.reviewSummary.reviewCount }）</span>
                </>
              ) : (
                <>
                  <span className="review-stars empty">★★★★★</span>
                  <span className="review-count">（0）</span>
                </>
              ) }
            </p>
            <small>{ donor.activeInText }</small>
          </div>
        </div>
        <div className="bottom-section">
          <div className="intro">
            { donor.basicInfo.comments && (
              <>
                { donor.basicInfo.comments.slice(0, 200).split('\n').map((line, i) => (
                  <React.Fragment key={ i }>
                    { i > 0 && <br/> }
                    { line }
                  </React.Fragment>
                )) }
              </>
            ) }
          </div>
        </div>
      </Link>
    </div>
  );
};

export default DonorCard;
